<template>
  <q-btn-dropdown icon="add" flat dense>
    <q-list no-border link :style="{ 'min-width': '180px' }">
      <q-list-header>{{ $tc('invoice', 2) }}</q-list-header>

      <q-item item :to="{ name: 'create-invoice', params: { teamId } }">
        <q-item-main :label="$t('quick_create.new_invoice')"/>
      </q-item>

      <q-item item :to="{ name: 'create-quote', params: { teamId } }">
        <q-item-main :label="$t('quick_create.new_quote')"/>
      </q-item>

      <q-item-separator/>

      <q-list-header>{{ $tc('customer', 2) }}</q-list-header>

      <q-item item :to="{ name: 'create-person', params: { teamId } }">
        <q-item-main :label="$t('quick_create.new_person')"/>
      </q-item>

      <q-item item :to="{ name: 'create-company', params: { teamId } }">
        <q-item-main :label="$t('quick_create.new_company')"/>
      </q-item>
    </q-list>
  </q-btn-dropdown>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'QuickCreate',

    computed: {
      ...mapGetters([
        'activeTeam'
      ]),

      teamId () {
        return this.activeTeam ? this.activeTeam.id : null
      }
    }
  }
</script>

<style scoped>

</style>
